module.exports = __webpack_public_path__ + "fonts/ProximaNovaAExCn-Extrabld.c2a8f512325b486ef5d3766d04a4a509.eot";